import { render, staticRenderFns } from "./b_data_management.vue?vue&type=template&id=30b8aeea&scoped=true&"
import script from "./b_data_management.vue?vue&type=script&lang=js&"
export * from "./b_data_management.vue?vue&type=script&lang=js&"
import style0 from "./b_data_management.vue?vue&type=style&index=0&id=30b8aeea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8aeea",
  null
  
)

export default component.exports